import {Component, Input, Output, SimpleChange, EventEmitter, OnChanges} from '@angular/core';

import {Grid} from './lib/grid';
import {DataSource} from './lib/data-source/data-source';
import {Row} from './lib/data-set/row';
import {deepExtend} from './lib/helpers';
import {LocalDataSource} from './lib/data-source/local/local.data-source';
import {NO_DATA_FOUND} from '../../../config';

@Component({
  selector: 'ng2-smart-table',
  styleUrls: ['./ng2-smart-table.component.scss'],
  templateUrl: './ng2-smart-table.component.html',
})
export class Ng2SmartTableComponent implements OnChanges {
  backgroundColor : any;
  @Input() source: any;
  @Input() settings: Object = {};

  @Output() rowSelect = new EventEmitter<any>();
  @Output() userRowSelect = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() custom = new EventEmitter<any>();
  @Output() deleteConfirm = new EventEmitter<any>();
  @Output() editConfirm = new EventEmitter<any>();
  @Output() createConfirm = new EventEmitter<any>();
  @Output() rowHover: EventEmitter<any> = new EventEmitter<any>();

  tableClass: string;
  tableId: string;
  isHideHeader: boolean;
  isHideSubHeader: boolean;
  isPagerDisplay: boolean;
  rowClassFunction: Function;
  isSelectDisplay: boolean;
  selectedPages: number = 10;
  selectOptions: number[] = [5,10, 20, 30, 40 , 50];
  totalRecordsDisplay: number;
  protected perPage: number;
  pagerTitle : string;



  grid: Grid;
  defaultSettings: Object = {
    mode: 'inline', // inline|external|click-to-edit
    selectMode: 'single', // single|multi
    hideHeader: false,
    hideSubHeader: false,
    pagerTitle : 'records',
    actions: {
      columnTitle: 'Actions',
      add: true,
      edit: true,
      delete: true,
      custom: [],
      position: 'left', // left|right
    },
    filter: {
      inputClass: '',
    },
    edit: {
      inputClass: '',
      editButtonContent: 'Edit',
      saveButtonContent: 'Update',
      cancelButtonContent: 'Cancel',
      confirmSave: false,
    },
    add: {
      inputClass: '',
      addButtonContent: 'Add New',
      createButtonContent: 'Create',
      cancelButtonContent: 'Cancel',
      confirmCreate: false,
    },
    delete: {
      deleteButtonContent: 'Delete',
      confirmDelete: false,
    },
    attr: {
      id: '',
      class: '',
    },
    noDataMessage: NO_DATA_FOUND,
    columns: {},
    pager: {
      display: true,
      perPage: 10,
    },
    rowClassFunction: () => ''
  };

  isAllSelected: boolean = false;
  hideLoader:boolean = false;

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    // document.getElementById('custom_spinner').style.display = 'block';
    this.hideLoader = false;

    if (this.grid) {
      if (changes['settings']) {
        this.grid.setSettings(this.prepareSettings());
      }
      if (changes['source']) {
        this.source = this.prepareSource();
        this.grid.setSource(this.source);
      }
    } else {
      this.initGrid();
    }
    /*if(+Object.keys(this.source['data']).length === 0){
      this.hideLoader = true;
    }*/
    this.tableId = this.grid.getSetting('attr.id');
    this.tableClass = this.grid.getSetting('attr.class');
    this.isHideHeader = this.grid.getSetting('hideHeader');
    this.isHideSubHeader = this.grid.getSetting('hideSubHeader');
    this.isPagerDisplay = this.grid.getSetting('pager.display');
    this.rowClassFunction = this.grid.getSetting('rowClassFunction');
    this.isSelectDisplay = this.grid.getSetting('pager.showSelectPage');
    this.selectOptions = this.grid.getSetting('pager').selectOptions || this.selectOptions;
    this.perPage = this.source.getPaging().perPage;
    this.pagerTitle = this.grid.getSetting('pagerTitle');

    if(this.source?.conf['allowLoader'] == false){
      this.hideLoader = true;
    } 

    this.selectedPages = this.source.getPaging().perPage|| this.selectedPages;

    this.source.getTotalRecords.subscribe((res) => {
      this.totalRecordsDisplay = res;
      // document.getElementById('custom_spinner').style.display = 'none';
      this.hideLoader = true;
    });
  }

  editRowSelect(row: Row) {
    if (this.grid.getSetting('selectMode') === 'multi') {
      this.onMultipleSelectRow(row);
    } else {
      this.onSelectRow(row);
    }
  }

  onUserSelectRow(row: Row) {
    if (this.grid.getSetting('selectMode') !== 'multi') {
      this.grid.selectRow(row);
      this.emitUserSelectRow(row);
      this.emitSelectRow(row);
    }
  }

  onRowHover(row: Row) {
    this.rowHover.emit(row);
  }

  multipleSelectRow(row: Row) {
    this.grid.multipleSelectRow(row);
    this.emitUserSelectRow(row);
    this.emitSelectRow(row);
  }

  onSelectAllRows($event: any) {
    this.isAllSelected = !this.isAllSelected;
    this.grid.selectAllRows(this.isAllSelected);

    this.emitUserSelectRow(null);
    this.emitSelectRow(null);
  }

  onSelectRow(row: Row) {
    this.grid.selectRow(row);
    this.emitSelectRow(row);
  }

  onMultipleSelectRow(row: Row) {
    this.emitSelectRow(row);
  }

  initGrid() {
    this.source = this.prepareSource();
    this.grid = new Grid(this.source, this.prepareSettings());
    this.grid.onSelectRow().subscribe((row) => this.emitSelectRow(row));
  }

  prepareSource(): DataSource {
    if (this.source instanceof DataSource) {
      return this.source;
    } else if (this.source instanceof Array) {
      return new LocalDataSource(this.source);
    }

    return new LocalDataSource();
  }

  prepareSettings(): Object {
    return deepExtend({}, this.defaultSettings, this.settings);
  }

  changePage($event: any) {
    // document.getElementById('custom_spinner').style.display = 'block';
    this.hideLoader = false;
    this.resetAllSelector();
  }

  sort($event: any) {
    this.resetAllSelector();
  }

  filter($event: any) {
    this.resetAllSelector();
  }

  onSelectPages(evt: any) {
    this.source.setPaging(this.source.pagingConf.page, +evt, true);
    this.hideLoader = false;
  }

  private resetAllSelector() {
    this.isAllSelected = false;
  }

  private emitUserSelectRow(row: Row) {
    const selectedRows = this.grid.getSelectedRows();

    this.userRowSelect.emit({
      data: row ? row.getData() : null,
      isSelected: row ? row.getIsSelected() : null,
      source: this.source,
      selected: selectedRows && selectedRows.length ? selectedRows.map((r: Row) => r.getData()) : [],
    });
  }

  private emitSelectRow(row: Row) {
    this.rowSelect.emit({
      data: row ? row.getData() : null,
      isSelected: row ? row.getIsSelected() : null,
      source: this.source,
    });
          // document.getElementById('custom_spinner').style.display = 'none';

  }

  shouldShow(): boolean {
    return this.source.count() > this.perPage && this.isSelectDisplay;
  }
}
